module.exports = __webpack_public_path__ + "img/open-modal.47fe2a75.svg";